<template>
    <v-card>
        <v-card-title class="pb-0 pt-1" >
            <v-icon style="background: #e7e8e9; padding: 10px!important; border-radius: 50%;" class="mr-4">mdi-file-document-outline</v-icon>
            <span >Alta de Nomina</span>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="6" md="4">
                <v-autocomplete  :rules="[v => !!v || 'Campo requerido']" clearable v-model="payroll.user_id" :items="usersLists" label="Empleado" item-text="name" item-value="id">
                    <template slot="no-data" class="pa-2">No existen usuarios relacionados.</template>                      
                </v-autocomplete>
            </v-col>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
            <v-container>
                <v-row>

                    <v-col cols="12" sm="6" md="6" class="pb-0">
                        <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                            <template v-slot:activator="{ on }">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="payroll.date" label="Fecha de Pago" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="payroll.date" @input="datePicker = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pb-0">
                        <v-text-field type=number v-model="payroll.amount" label="Monto"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                        <v-menu v-model="periodStartPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                            <template v-slot:activator="{ on }">
                                <v-text-field clearable v-model="payroll.period_start" label="Inicio periodo" prepend-icon="mdi-calendar-start" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="payroll.period_start" @input="periodStartPicker = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                        <v-menu v-model="periodEndPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                            <template v-slot:activator="{ on }">
                                <v-text-field clearable v-model="payroll.period_end" label="Fin periodo" prepend-icon="mdi-calendar-end" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="payroll.period_end" @input="periodEndPicker = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" class="py-0">
                        <v-text-field type=number v-model="payroll.paid_days" label="Días pagados"></v-text-field>
                    </v-col>

                    
                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.imss" label="IMSS"></v-text-field>
                        <v-text-field type=number v-model="payroll.isr_deduction" label="Deducción ISR"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.production_award" label="Premio Producción"></v-text-field>
                    </v-col>


                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.infonavit" label="Infonavit"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.performance_award" label="Premio Rendimiento"></v-text-field>
                    </v-col>


                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.absence_days" label="Faltas (días)" hint="El sistema calcula el monto a descontar." persistent-hint></v-text-field>
                        <v-text-field :value="absenceAmount.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})" label="Monto por faltas" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.punctuality_award" label="Premio Puntualidad"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.loan" label="Prestamo"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field type=number v-model="payroll.extra_time" label="Tiempo Extra"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-container fluid>
                            <v-textarea v-model="payroll.notes" label="Notas"></v-textarea>
                        </v-container>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pt-0">
                        <v-text-field type=number v-model="payroll.holidays" label="Vacaciones"></v-text-field>
                        <v-text-field type=number v-model="payroll.prima_vacacional" label="Prima Vacacional"></v-text-field>
                        <v-text-field type=number v-model="payroll.benefits" label="Prestaciones"></v-text-field>
                    </v-col>

                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
            <div style="font-size:21px;"><strong>Total a Pagar: </strong>{{neto.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',})}}</div>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
                Cancelar
            </v-btn>
            <v-btn color="blue darken-1" text @click="save" :loading="gris" :disabled="gris || grey">
                Guardar
            </v-btn>
            <v-btn color="blue darken-1" text @click="save(true)" :loading="stampLoading" :disabled="gris || stampLoading || grey" v-show="permissions('timbrarPayrolls')">
                Crear y timbrar
            </v-btn>
        </v-card-actions>

        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            gris:false,
            stampLoading:false,
            datePicker:'',
            periodStartPicker:false,
            periodEndPicker:false,
            payroll:{
                date:'',
                period_start:'',
                period_end:'',
                paid_days:15,
                user_id:'',
                imss:null,
                isr_deduction:null,
                infonavit:null,
                amount:null,
                extra_time:null,
                production_award:null,
                punctuality_award:null,
                performance_award:null,
                absence:null,
                absence_days:null,
                benefits:null,
                loan:null,
                prima_vacacional:null,
                holidays:null,

                notes:'',
            },
            rules: {
                required: value => !!value || 'Campo requerido',
            },
            valid: true,
        }),
        computed: {
            grey(){
                if(this.payroll.user_id=='' || this.payroll.user_id==null || this.payroll.user_id==undefined){
                    return true 
                }else{
                    return false
                }
            },
            neto(){
                return (this.payroll.amount*1)
                - (this.payroll.imss*1)
                - (this.payroll.isr_deduction*1)
                - (this.payroll.infonavit*1)
                - this.absenceAmount
                - (this.payroll.loan*1)
                + (this.payroll.extra_time*1)
                + (this.payroll.production_award*1)
                + (this.payroll.punctuality_award*1)
                + (this.payroll.performance_award*1)
                + (this.payroll.prima_vacacional*1)
                + (this.payroll.holidays*1)
                + (this.payroll.benefits*1)
                
            },
            absenceAmount(){
                const amount = Number(this.payroll.amount || 0)
                const paidDays = Number(this.payroll.paid_days || 0)
                const absenceDays = Number(this.payroll.absence_days || 0)

                if(paidDays <= 0 || absenceDays <= 0){
                    return 0
                }

                return Math.round(((amount / paidDays) * absenceDays + Number.EPSILON) * 100) / 100
            },
            usersLists(){
                return this.$store.getters['user/activeUsers'].map(id=>{
                    return{
                        id:id.id,
                        name:id.name + ' ' + id.last,
                        daily_salary:id.daily_salary,
                        payroll_fiscal_profile:id.payroll_fiscal_profile
                    }
                });
            }, 
            currentUser:{
                get(){
                    return this.$store.state.currentUser.user
                }
            },
        },
        methods: {
            permissions(permission){
                if(this.currentUser.id==1){
                    return true
                }else if(this.currentUser.permissions!=undefined){
                    if(this.currentUser.permissions.includes(permission)){
                        return true
                    }else{
                        return false
                    }
                }else{
                    return false
                }
            },
            close () {

                
                this.payroll={
                    date:'',
                    period_start:'',
                    period_end:'',
                    paid_days:15,
                    user_id:'',
                    imss:null,
                    isr_deduction:null,
                    infonavit:null,
                    amount:null,
                    extra_time:null,
                    production_award:null,
                    punctuality_award:null,
                    performance_award:null,
                    absence:null,
                    absence_days:null,
                    benefits:null,
                    loan:null,
                    prima_vacacional:null,
                    holidays:null,

                    notes:'',
                }

                if(this.company!=undefined){
                    this.payroll.company_id=Number(this.company)
                }
                this.gris = false
                this.stampLoading = false
                this.$nextTick(() => {
                    this.$emit("closeCreateDialogPayroll", false);
                })
            },
            save(stampAfterCreate = false){
                this.gris = !stampAfterCreate
                this.stampLoading = stampAfterCreate
                this.payroll.created_by_user_id = this.currentUser.id
                this.payroll.last_updated_by_user_id = this.currentUser.id
                axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/payrolls", Object.assign({}, this.payroll, {
                    absence: this.absenceAmount,
                    stamp_after_create: stampAfterCreate
                })).then(()=>{
                    this.close()
                }).catch(error => {
                    this.snackbar = {
                        message: this.errorMessage(error),
                        color: 'error',
                        show: true
                    }
                    this.gris = false
                    this.stampLoading = false
                })
            },
            errorMessage(error){
                if(error.response && error.response.data){
                    if(error.response.data.errors){
                        return Object.values(error.response.data.errors).flat().join(', ')
                    }
                    if(error.response.data.message){
                        return error.response.data.message
                    }
                }
                return 'Ocurrió un error'
            },
            selectedUser(){
                return this.usersLists.find(user => String(user.id) === String(this.payroll.user_id))
            },
            payrollDaysFromFrequency(frequency){
                const days = {
                    '01': 1,
                    '02': 7,
                    '03': 14,
                    '04': 15,
                    '05': 30,
                    '10': 10,
                }

                return days[String(frequency || '')] || null
            },
            fillPayrollFromUser(user, applyFrequency = true){
                if(!user){
                    return
                }

                const profile = user.payroll_fiscal_profile || {}
                const paidDays = this.payrollDaysFromFrequency(profile.periodicidad_pago)
                if(applyFrequency && paidDays){
                    this.payroll.paid_days = paidDays
                }

                const dailySalary = Number(profile.salario_diario_integrado || user.daily_salary || 0)
                if(dailySalary > 0){
                    this.payroll.amount = Math.round((dailySalary * Number(this.payroll.paid_days || 0) + Number.EPSILON) * 100) / 100
                }
            },
        },
        watch:{
            'payroll.user_id':{
                handler(){
                    this.fillPayrollFromUser(this.selectedUser())
                }
            },
            'payroll.paid_days':{
                handler(){
                    this.fillPayrollFromUser(this.selectedUser(), false)
                }
            }
        }
    }
</script>
<style lang="css" scoped>
.v-text-field >>> label{
    font-size: 14px!important;
}
.v-input__icon--prepend-inner i::before {
    font-size: 18px!important;
    color:#1976D2;
}
.v-text-field input, .v-label {
    font-size: 14px;
}
.v-picker__title.primary{
    display:none;
}
</style>
